import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { DEPARTMENTS_ENDPOINT, getBaseUrl } from '../../constants';

/**
 * repository for department
 */
export class Departments {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Departments(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.endpoint = DEPARTMENTS_ENDPOINT;
  }

  get base_url() {
    return getBaseUrl();
  }

  /**
   * to get all department
   * @param {Object} reqParam
   * @returns response in required formate of all department
   */

  async getAllDepartment(reqParam) {
    const queryString = queryBuilder(reqParam);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }

  async postDepartment(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async putDepartmentById(req) {
    const url = `${this.base_url}${this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.putData(url, req.reqBody);
    return response?.data;
  }

  async deleteDepartmentById(req) {
    const url = `${this.base_url}${this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.deleteData(url, req.reqBody);
    return response;
  }
}

export const createDepartments = () => Departments.getInstance();
